import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FloatingShapes, GradientBlob, DottedPattern } from './DecorativeElements';
import './HeroSection.css';

const HeroSection = () => {
  const animatedTextRef = useRef(null);

  useEffect(() => {
    const text = animatedTextRef.current;
    if (!text) return;

    const animateText = () => {
      text.style.animation = 'none';
      setTimeout(() => {
        text.style.animation = 'scroll-text 30s linear infinite';
      }, 10);
    };

    animateText();
  }, []);

  const handleWorkClick = (e) => {
    e.preventDefault();
    const element = document.getElementById('work');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact';
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <section className="hero-section">
      <DottedPattern />
      <FloatingShapes />
      <GradientBlob className="blob-1" />
      <GradientBlob className="blob-2" />
      <div className="hero-container">
        <motion.div
          className="hero-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div className="hero-intro-text" variants={itemVariants}>
            It's what you can expect
          </motion.div>

          <motion.h1 className="hero-title" variants={itemVariants}>
            <span className="hero-line-1">when you work with one of the</span>
            <span className="hero-line-2">country's largest</span>
            <span className="hero-line-3">full-service independent agencies.</span>
          </motion.h1>

          <motion.p className="hero-subtitle" variants={itemVariants}>
            We nurture your brands like we treat our people:<br />
            with <span className="highlight-creativity">creativity</span> and <span className="highlight-compassion">compassion</span>.
          </motion.p>

          <motion.div className="hero-buttons" variants={itemVariants}>
            <motion.a
              href="#work"
              onClick={handleWorkClick}
              className="btn-primary"
              whileHover={{ scale: 1.05, x: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              View Our Work
            </motion.a>
            <motion.a
              href="#contact"
              onClick={handleContactClick}
              className="btn-secondary"
              whileHover={{ scale: 1.05, x: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              Let's Talk <ArrowRight size={20} />
            </motion.a>
          </motion.div>

          <motion.div className="hero-stats" variants={itemVariants}>
            <div className="stat-item">
              <div className="stat-number">4+</div>
              <div className="stat-label">Years</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">350+</div>
              <div className="stat-label">Projects</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">Satisfaction</div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      <div className="hero-animated-text">
        <div className="animated-text-wrapper" ref={animatedTextRef}>
          <span className="animated-text">IT'S TIME TO CREATE A FULLSTACK</span>
          <span className="animated-text">IT'S TIME TO CREATE A FULLSTACK</span>
          <span className="animated-text">IT'S TIME TO CREATE A FULLSTACK</span>
          <span className="animated-text">IT'S TIME TO CREATE A FULLSTACK</span>
          <span className="animated-text">IT'S TIME TO CREATE A FULLSTACK</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
